import axiosInstance from "../../config/axios-config"

const options = (language, signal) => ({headers: {"Language-Context": language.toUpperCase()}, signal})

export const isEligibleCourier = (courier, tenantId) => courier.tenantId === tenantId
    && courier.active === true && courier.availability === "AVAILABLE" && courier.remainingCapacity > 0

export const courierName = courier => [courier?.userName, courier?.userSurname].filter(Boolean).join(" ")
    || courier?.userEmail || courier?.userId || ""

export const getEligibleCouriers = async (tenantId, language, signal) => {
    const couriers = []
    let page = 0, totalPages = 1
    // The profile API is paginated; an unavailable first page must not hide eligible couriers later on.
    while (page < totalPages) {
        if (signal?.aborted) return []
        const {data} = await axiosInstance.get("/api/v1/couriers", {
            ...options(language, signal), params: {page, size: 200},
        })
        couriers.push(...data.content.filter(courier => isEligibleCourier(courier, tenantId)))
        totalPages = data.totalPages
        page += 1
    }
    return couriers
}

export const getCourierOrder = async (orderNumber, language, signal, buyerId) => {
    const {data} = await axiosInstance.get(`/api/v1/orders/importer/${encodeURIComponent(orderNumber)}`,
        {...options(language, signal), params: {buyerId}})
    return data
}

export const getCourierProfile = async (id, language, signal) => {
    const {data} = await axiosInstance.get(`/api/v1/couriers/${id}`, options(language, signal))
    return data
}

export const getCourierOrderTimeline = async (orderId, language, signal) => {
    const {data} = await axiosInstance.get(`/api/v1/orders/importer/timeline/${orderId}`, options(language, signal))
    return data
}

export const assignOrderCourier = async (orderId, courierProfileId, language) => {
    const {data} = await axiosInstance.post(`/api/v1/orders/${orderId}/courier-assignment`,
        {courierProfileId}, options(language))
    return data
}

export const unassignOrderCourier = async (orderId, assignmentId, language) => {
    await axiosInstance.delete(`/api/v1/orders/${orderId}/courier-assignment`,
        {...options(language), params: {assignmentId}})
}

export const reassignOrderCourier = async (orderId, assignmentId, courierProfileId, reason, language) => {
    const {data} = await axiosInstance.post(`/api/v1/orders/${orderId}/courier-reassignment`,
        {assignmentId, courierProfileId, reason}, options(language))
    return data
}

export const getCourierAssignmentHistory = async (orderId, language, signal) => {
    const {data} = await axiosInstance.get(`/api/v1/orders/${orderId}/courier-assignments`, options(language, signal))
    return data
}
